
<script lang="ts">
    import { ModalToken } from "@/modal-manager";
    import type InstagramPostEntity from "@apps/instagram/entities/InstagramPostEntity";

    import InstagramPost from "../components/InstagramPost.svelte";
    import InstagramPostSkeleton from "../components/InstagramPostSkeleton.svelte";
    import {
        DISPLAY_MODE_HOTSPOT_TYPE,
        DISPLAY_MODE_SHOP_IT_TYPE,
    } from "../constants";

    export let skeleton = false;
    export let skeletonPostsCount = 8;
    export let posts: InstagramPostEntity[];
    export let rows: number;
    export let columns: number;
    export let postModalToken: ModalToken<{ id: number }>;
    export let displayMode:
        | typeof DISPLAY_MODE_SHOP_IT_TYPE
        | typeof DISPLAY_MODE_HOTSPOT_TYPE
        | null;
    export let highQualityEnabled: boolean;
</script>

<div
    style={[
        `--gw-grid-layout-columns: ${columns}`,
        `--gw-grid-layout-rows: ${rows}`,
    ].join(";")}
    class="gw-ig-gallery-listing-layout"
>
    {#if skeleton}
        {#each Array(skeletonPostsCount).fill(null) as _}
            <div class="gw-ig-gallery-listing-layout__post-wrapper">
                <InstagramPostSkeleton square={true} />
            </div>
        {/each}
    {:else}
        {#each posts as post}
            <div class="gw-ig-gallery-listing-layout__post-wrapper">
                <InstagramPost
                    {post}
                    {postModalToken}
                    imageObjectFit="cover"
                    {displayMode}
                    {highQualityEnabled}
                />
            </div>
        {/each}
    {/if}
</div>

<style>
    .gw-ig-gallery-listing-layout {
        display: grid;
        grid-template-columns: repeat(
            var(--gw-grid-layout-columns),
            minmax(0, 1fr)
        );
        grid-auto-rows: 1fr;
        max-width: 100%;
    }
    .gw-ig-gallery-listing-layout:empty {
        display: none;
    }
    /*  very intresting hack... in container we define, that  */
    .gw-ig-gallery-listing-layout::before {
        content: "";
        width: 0;
        padding-bottom: 100%;
        grid-row: 1 / 1;
        grid-column: 1 / 1;
    }
    .gw-ig-gallery-listing-layout > *:first-child {
        grid-row: 1 / 1;
        grid-column: 1 / 1;
    }

    .gw-ig-gallery-listing-layout__post-wrapper {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 0.3em;
        box-shadow: 0 1px 6px rgb(0 0 0 / 0.6);
    }

    @media screen and (max-width: 670px) {
        .gw-ig-gallery-listing-layout {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }
</style>
